// extracted by mini-css-extract-plugin
module.exports =  {"provider-logo":"a10a3f92e9--provider-logo--hjeBQ","placeholder-logo":"a10a3f92e9--placeholder-logo--nRJOy","bank-logo":"a10a3f92e9--bank-logo--k3lQd"};